export default "__VITE_ASSET__4d79c683__"